import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { usersControllerGetUserInfo } from 'api.gen'
import { customInstance } from 'lib/api-instance'
import useFeatureToggles from 'utils/hooks/use-feature-toggles'

export const useHybridOfferAdmin = () => {
  const { featureToggles } = useFeatureToggles()
  const [hasSelection, setHasSelection] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const flagValue = featureToggles.hybridOffer === true

  const { data: entityId } = useQuery({
    queryKey: ['hybrid-offer-entity-id'],
    queryFn: async () => {
      const response = await usersControllerGetUserInfo()
      if (response.status === 200) {
        return response.data.entity_id
      }
      return null
    }
  })

  useEffect(() => {
    if (!entityId) {
      setIsLoading(false)
      return
    }

    let cancelled = false

    customInstance<{
      data: { data: { hasSelection: boolean } }
      status: number
      headers: Headers
    }>(
      `/api-arvore/hybrid-offer/selection/has-selection?entityId=${entityId}`,
      { method: 'GET' }
    )
      .then(response => {
        if (cancelled) return
        setHasSelection(response.data.data.hasSelection === true)
        setIsLoading(false)
      })
      .catch(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [entityId])

  const isHybridOfferEnabled = flagValue && hasSelection

  return { isHybridOfferEnabled, isLoading }
}
